import {
  FETCH_SECTIONS_REQUEST, FETCH_SECTIONS_SUCCESS, FETCH_SECTIONS_FAILURE,
  UPDATE_SECTION_REQUEST, UPDATE_SECTION_SUCCESS, UPDATE_SECTION_FAIL, UPDATE_SECTION_RESET,
} from '../constants/additionalSectionsConstants';

const initialState = {
  loading: false,
  sections: [],
  error: null,
};

export const additionalSectionsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SECTIONS_REQUEST:
      return { ...state, loading: true };
    case FETCH_SECTIONS_SUCCESS:
      return { loading: false, sections: action.payload };
    case FETCH_SECTIONS_FAILURE:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const additionalSectionsUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_SECTION_REQUEST:
      return { loading: true };
    case UPDATE_SECTION_SUCCESS:
      return { loading: false, success: true };
    case UPDATE_SECTION_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_SECTION_RESET:
      return {};
    default:
      return state;
  }
};